import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { reactive, ref, watch, watchEffect } from 'vue';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import CropService from '../../Services/CropService';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import RootstockService from '../../Services/RootstockService';
import TrainingSystemService from '../../Services/TrainingSystemService';
import SaveCancelButtons from '../../Components/SaveCancelButtons.vue';
import { useSpinner } from '../../Plugins/spinner';
import { useAxios } from '../../Plugins/axios';
import { Inertia } from '@inertiajs/inertia';
import { trans } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrchardDetailsForm',
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    emits: ['saved', 'cancel'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const spinner = useSpinner();
        const axios = useAxios();
        const cropService = new CropService();
        const rootstockService = new RootstockService();
        const trainingSystemService = new TrainingSystemService();
        const data = reactive({
            name: props.data.name,
            land: props.data.land,
            place: props.data.place,
            city: props.data.city,
            postal_code: props.data.postal_code,
            state: props.data.state,
            country: props.data.country,
            latitude: props.data.latitude,
            longitude: props.data.longitude,
            altitude: props.data.altitude,
            area: props.data.area,
            slope: props.data.slope,
            crop_id: props.data.crop_id,
            crop_variety_id: props.data.crop_variety_id,
            age: props.data.age,
            plants_distance: props.data.plants_distance,
            rows_distance: props.data.rows_distance,
            production_last_three_years: props.data.production_last_three_years,
            production_expected: props.data.production_expected,
            rootstock_id: props.data.rootstock_id,
            training_system_id: props.data.training_system_id,
        });
        const rules = {
            name: { required },
            land: { required },
            place: { required },
            city: { required },
            postal_code: { required },
            state: { required },
            country: { required },
            latitude: { required },
            longitude: { required },
            altitude: { required },
            area: { required },
            slope: { required },
            crop_id: { required },
            crop_variety_id: { required },
            age: { required },
            plants_distance: { required },
            rows_distance: { required },
            production_last_three_years: { required },
            production_expected: { required },
            rootstock_id: { required },
            training_system_id: { required },
        };
        const v$ = useVuelidate(rules, data);
        const cropVarieties = ref([]);
        watch(() => v$.value.crop_id.$model, () => {
            if (v$.value.crop_id.$model !== undefined) {
                cropService.getAllVarieties(v$.value.crop_id.$model).then((res) => {
                    cropVarieties.value = res.map((c) => ({
                        label: c.name,
                        value: c.id,
                    }));
                });
            }
        }, { immediate: true });
        const crops = ref([]);
        cropService.getAll().then((res) => {
            crops.value = res.map((c) => ({
                label: c.name,
                value: c.id,
            }));
        });
        watch(() => v$.value.crop_id.$model, () => (v$.value.crop_variety_id.$model = undefined));
        const rootstocks = ref([]);
        rootstockService.getAll().then((res) => {
            rootstocks.value = res.map((c) => ({
                label: c.name,
                value: c.id,
            }));
        });
        const trainingSystems = ref([]);
        trainingSystemService.getAll().then((res) => {
            trainingSystems.value = res.map((c) => ({
                label: c.name,
                value: c.id,
            }));
        });
        const save = async () => {
            const valid = await v$.value.$validate();
            if (!valid) {
                return;
            }
            let url = `/api/orchards`;
            if (props.data.id) {
                url += `/${props.data.id}`;
            }
            const data = {
                name: v$.value.name.$model,
                land: v$.value.land.$model,
                place: v$.value.place.$model,
                city: v$.value.city.$model,
                postal_code: v$.value.postal_code.$model,
                state: v$.value.state.$model,
                country: v$.value.country.$model,
                latitude: v$.value.latitude.$model,
                longitude: v$.value.longitude.$model,
                altitude: v$.value.altitude.$model,
                area: v$.value.area.$model,
                slope: v$.value.slope.$model,
                crop_id: v$.value.crop_id.$model,
                crop_variety_id: v$.value.crop_variety_id.$model,
                age: v$.value.age.$model,
                plants_distance: v$.value.plants_distance.$model,
                rows_distance: v$.value.rows_distance.$model,
                production_last_three_years: v$.value.production_last_three_years.$model,
                production_expected: v$.value.production_expected.$model,
                rootstock_id: v$.value.rootstock_id.$model,
                training_system_id: v$.value.training_system_id.$model,
            };
            if (props.data.id) {
                data['_method'] = 'PATCH';
            }
            spinner.show();
            axios
                .post(url, data)
                .then((res) => {
                emit('saved', res.data.data);
                Inertia.reload({ only: ['orchard'] });
            })
                .catch((err) => {
                console.log(err);
            })
                .finally(() => {
                spinner.hide();
            });
        };
        const __returned__ = { spinner, axios, props, emit, cropService, rootstockService, trainingSystemService, data, rules, v$, cropVarieties, crops, rootstocks, trainingSystems, save, get InputText() { return InputText; }, get InputNumber() { return InputNumber; }, get Dropdown() { return Dropdown; }, SaveCancelButtons, get trans() { return trans; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
